import { render, staticRenderFns } from "./tp-order-detail.vue?vue&type=template&id=3a8fb054&scoped=true&"
import script from "./tp-order-detail.vue?vue&type=script&lang=js&"
export * from "./tp-order-detail.vue?vue&type=script&lang=js&"
import style0 from "./tp-order-detail.vue?vue&type=style&index=0&id=3a8fb054&lang=stylus&rel=stylesheet%2Fstylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a8fb054",
  null
  
)

export default component.exports